import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/toaster";
import api from "./lib/api";

import Home from "./pages/Home";
import ForBusinesses from "./pages/ForBusinesses";
import ForGyms from "./pages/ForGyms";
import Affiliates from "./pages/Affiliates";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import RequestDemo from "./pages/RequestDemo";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Audit from "./pages/Audit";
import Privacy from "./pages/legal/Privacy";
import Terms from "./pages/legal/Terms";
import MedicalDisclaimer from "./pages/legal/MedicalDisclaimer";
import NotFound from "./pages/NotFound";

const REF_COOKIE = "fitest_ref";
const REF_COOKIE_DAYS = 30;

function setRefCookie(value) {
  const expires = new Date(Date.now() + REF_COOKIE_DAYS * 86400 * 1000).toUTCString();
  document.cookie = `${REF_COOKIE}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getRefCookie() {
  const match = document.cookie.match(new RegExp("(^| )" + REF_COOKIE + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : "";
}

function ReferralTracker() {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");
    if (ref && /^[a-fA-F0-9]{12,32}$/.test(ref)) {
      setRefCookie(ref);
      api.post("/affiliate/track-click", { ref }).catch(() => {});
    }
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "Fitest — Enterprise Wellness Audits";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ReferralTracker />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/for-businesses" element={<ForBusinesses />} />
              <Route path="/for-gyms" element={<ForGyms />} />
              <Route path="/affiliates" element={<Affiliates />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request-demo" element={<RequestDemo />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/legal/privacy" element={<Privacy />} />
              <Route path="/legal/terms" element={<Terms />} />
              <Route path="/legal/medical-disclaimer" element={<MedicalDisclaimer />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/audit/:slug" element={<Audit />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
